export default __webpack_public_path__ + "static/media/sprite-tto_v2.8ce70e45.webp";